<template>
<div class="container-fluid">
      <div class="row">
        <div class="col-12 p-0">
          <div class="jumbotron min-vh-100 d-flex flex-column justify-content-center">
            <h1 class="display-4 w-50 ">UX, product design and analytics for e-commerce and SaaS</h1>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'AlertsComp',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
